import { FC, useCallback } from 'react'

import { useTranslation } from '../../../../../hooks/locale'
import EventRegionsAutocompleteSuggestionTransport from '../../../../../transports/event/event-regions-autocomplete-suggestion-transport'
import { LocationItemComponentProps } from '../../../../common/location-picker/types'
import { ItemContainer } from '../../../../common/location-picker/location-picker-items-styles'
import { SuggestionItemTitle } from '../../../../search-result-listing/header-section/searchbar/regions-autocomplete-suggestion-picker/regions-autocomplete-suggestion-styles'

import { LocationPinIcon } from '../../../../common/icons'

const LocationPickerSuggestion: FC<LocationItemComponentProps<EventRegionsAutocompleteSuggestionTransport>> = ({
    item,
    onSelect,
    isFocused,
    onFocus,
}) => {
    const { t } = useTranslation()

    const _handleMouseEnter = useCallback(() => onFocus(item), [onFocus, item])
    const _handleMouseLeave = useCallback(() => onFocus(null), [onFocus])
    const _handleSelect = useCallback(() => onSelect(item), [item, onSelect])

    return (
        <ItemContainer
            onClick={_handleSelect}
            isFocused={isFocused}
            onMouseEnter={_handleMouseEnter}
            onMouseLeave={_handleMouseLeave}
        >
            <LocationPinIcon aria-label={t('mapIconText')} />
            <SuggestionItemTitle>{item}</SuggestionItemTitle>
        </ItemContainer>
    )
}

export default LocationPickerSuggestion
